import { get, post, put, del } from '../client/axiosClient';
import { disbursementEndpoints } from '../endpoints/disbursement.endpoints';
import { buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type {
  ApiResponse, PaginatedResponse, EmptyResponse, ID,
  Disbursement, CreateDisbursementRequest, UpdateDisbursementRequest, DisbursementSearchRequest,
} from '../types';

class DisbursementService {
  async getAll(params?: DisbursementSearchRequest): Promise<PaginatedResponse<Disbursement>> {
    const endpoint = params
      ? buildEndpointWithQuery(disbursementEndpoints.basePath(), params as Record<string, any>)
      : disbursementEndpoints.list();
    const response = await get<any>(endpoint);
    const raw = response.data;
    const pagedResult = raw?.data ?? {};
    return {
      success: raw?.success ?? false,
      message: raw?.message,
      data: pagedResult.items ?? [],
      pagination: {
        currentPage: pagedResult.page ?? 1,
        pageSize: pagedResult.pageSize ?? 20,
        totalPages: pagedResult.totalPages ?? 0,
        totalItems: pagedResult.totalCount ?? 0,
        hasNextPage: pagedResult.hasNext ?? false,
        hasPreviousPage: pagedResult.hasPrevious ?? false,
      },
    };
  }

  async getById(id: ID): Promise<ApiResponse<Disbursement>> {
    const response = await get<ApiResponse<Disbursement>>(disbursementEndpoints.getById(id));
    return response.data;
  }

  async create(data: CreateDisbursementRequest): Promise<ApiResponse<Disbursement>> {
    const response = await post<ApiResponse<Disbursement>>(disbursementEndpoints.create(), data);
    return response.data;
  }

  async update(id: ID, data: UpdateDisbursementRequest): Promise<ApiResponse<Disbursement>> {
    const response = await put<ApiResponse<Disbursement>>(disbursementEndpoints.update(id), data);
    return response.data;
  }

  async delete(id: ID): Promise<EmptyResponse> {
    await del<void>(disbursementEndpoints.delete(id));
    return { success: true };
  }
}

export const disbursementService = new DisbursementService();
export default disbursementService;
